export const getBaseUri =(inputUri :string)=> {
    const url = new URL(inputUri);
    const isLocalhost = url.hostname === "localhost";
  
    const base = `${url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ''}`;
  
    return isLocalhost ? base : `${base}/api`;
  }